<template>
    <div v-if="formReady">
        <div
            class="box-tahapan"
            v-for="(t, i) in tahapan"
            :key="t.idtahapan"
            :class="{ 'box-tahapan-top': i === 0, 'box-tahapan-bottom': i === tahapan.length - 1 }"
        >
            <div class="d-flex-between-center p-x-16 p-y-12 align-items-center" @click="expand(t.idtahapan)">
                <div class="f-regular f-16 f-c-black">{{ t.text }}</div>
                <div class="d-flex align-items-center">
                    <span class="badge color-blue m-r-12" v-if="upah[t.idtahapan].percent.raw > 0">
                        Diatur
                    </span>
                    <div
                        class="fas fa-chevron-down f-c-midgrey"
                        :id="'chev-' + t.idtahapan"
                    ></div>
                        <!-- :class="{ 'chev-180': isVisible[t.idtahapan] }" -->
                </div>
            </div>
            <div v-show="false" :id="'form-tahapan-' + t.idtahapan">
                <div class="d-flex p-x-16 p-d-20">
                    <div class="p-r-12" style="width: 65%">
                        <SOInputNominal
                            :placeholder="'14.000'"
                            :title="'Rupiah'"
                            :id="'input-tahapan-' + t.idtahapan"
                            :required="false"
                            :prefix-left="true"
                            :prefix="'Rp'"
                            :max-value="hargaLayanan.toString()"
                            :default-value="upah[t.idtahapan].rupiah.formatted"
                            :use-comma="true"
                            v-model="upah[t.idtahapan].rupiah"
                            @input="
                                (val) => {
                                    convertingToPercent(t.idtahapan, val);
                                }
                            "
                        />
                        <div class="f-regular f-12 f-c-midgrey">
                            *Dalam rupiah
                        </div>
                    </div>
                    <div style="width: 35%">
                        <div class="input-group remove-padding">
                            <SOInputNominal
                                :placeholder="'0'"
                                :title="'Persentase'"
                                :id="'input-persentase-tahapan-' + t.idtahapan"
                                :required="false"
                                :prefix-right="true"
                                :prefix="'%'"
                                :is-percent="true"
                                :default-value="upah[t.idtahapan].percent.formatted"
                                :use-comma="true"
                                v-model="upah[t.idtahapan].percent"
                                @input="
                                    (val) => {
                                        convertingToRupiah(t.idtahapan, val);
                                    }
                                "
                            />
                        </div>
                        <div class="f-regular f-12 f-c-midgrey">
                            *Dalam persen
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SOInputNominal from "@/so-components/global/input/SOInputNominal";

export default {
    name: "UpahBoronganV3",
    components: {
        SOInputNominal,
    },
    props: {
        hargaLayanan: Number,
        tahapan: Array,
        upahBorongan: Object,
    },
    data() {
        return {
            isVisible: {},
            upah: {},
            upahClone: {},
            formReady: false,
            mode: {
                rupiah: false,
                percent: false,
            },
        };
    },
    mounted() {
        this.setup();
    },
    watch: {
        hargaLayanan: function(newVal, oldVal) {
            if (newVal !== oldVal && oldVal > 0) {
                this.recalculate();
            }
        },
        tahapan: {
            handler: function() {
                this.setup();
            },
            deep: true,
        },
        upahBorongan: {
            handler: function() {
                this.setup();
            },
            deep: true,
        },
    },
    methods: {
        async setup() {
            await this.setDataUpah();
            await this.$emit("upah", this.upah);
            await this.setFormReady();
            this.upahClone = this.upahBorongan;
        },
        setDataUpahDefault() {
            for (let i = 0; i < this.tahapan.length; i++) {
                this.upah[this.tahapan[i].idtahapan] = {
                    rupiah: {
                        idtahapan: this.tahapan[i].idtahapan,
                        text: this.tahapan[i].text,
                        value: 0,
                        raw: 0,
                        formatted: "0",
                    },
                    percent: {
                        idtahapan: this.tahapan[i].idtahapan,
                        text: this.tahapan[i].text,
                        value: 0,
                        raw: 0,
                        formatted: "0",
                    },
                };
                this.isVisible[this.tahapan[i].idtahapan] = false;
            }
        },
        setDataUpah() {
            if (this.upahBorongan !== undefined) {
                let newUpah = {};
                this.tahapan.forEach((tahapan) => {
                    if (this.upahBorongan[tahapan.idtahapan] === undefined) {
                        // run fallback
                        this.setDataUpahDefault();
                        this.recalculate();
                        return;
                    }
                    newUpah[tahapan.idtahapan] = {
                        rupiah: {
                            idtahapan: this.upahBorongan[tahapan.idtahapan].idtahapan,
                            text: this.upahBorongan[tahapan.idtahapan].text,
                            value: this.upahBorongan[tahapan.idtahapan].value,
                            raw: parseFloat(this.upahBorongan[tahapan.idtahapan].raw),
                            formatted: this.upahBorongan[tahapan.idtahapan].formatted,
                        },
                        percent: {
                            idtahapan: this.upahBorongan[tahapan.idtahapan].idtahapan,
                            text: this.upahBorongan[tahapan.idtahapan].text,
                            value: this.upahBorongan[tahapan.idtahapan].value,
                            raw: this.rupiahToPrecent(this.hargaLayanan, this.upahBorongan[tahapan.idtahapan].raw),
                            formatted: this.rupiahToPrecent(
                                this.hargaLayanan,
                                this.upahBorongan[tahapan.idtahapan].raw
                            ).toString().replace(".", ","),
                        },
                    };

                    if (parseFloat(this.upahBorongan[tahapan.idtahapan].raw) !== 0) {
                        /** Set Buka form ketika ada datanya */
                        // setTimeout(() => {
                        //   $("#form-tahapan-" + tahapan.idtahapan).show();
                        // }, 100);
                        this.isVisible[tahapan.idtahapan] = true;

                    } else {
                        this.isVisible[tahapan.idtahapan] = false;
                    }
                });
                this.upah = newUpah;
            } else {
                this.setDataUpahDefault();
            }
        },
        setFormReady() {
            this.formReady = true;
        },
        setHargaLayanan(harga) {
            this.hargaLayanan = harga;
        },

        expand(id) {
            $("#form-tahapan-" + id).slideToggle(300);
            this.isVisible[id] = !this.isVisible[id];
            if (this.isVisible[id]) {
              $("#chev-" + id).removeClass("chev-180");
              $("#chev-" + id).addClass("chev-0");
            } else {
              $("#chev-" + id).addClass("chev-180");
              $("#chev-" + id).removeClass("chev-0");
            }
        },

        removeUpahBorongan(id) {
            $("#tahapan-" + id).show();
            $("#form-tahapan-" + id).hide();

            this.upah[id].percent.formatted = "0";
            this.upah[id].percent.raw = 0;
            this.upah[id].rupiah.formatted = "0";
            this.upah[id].rupiah.raw = 0;
        },
        convertingToRupiah(id, val) {
            if (this.mode.rupiah) {
                return;
            }
            if (!this.mode.percent) {
                this.mode.rupiah = false;
                this.mode.percent = true;
                setTimeout(() => {
                    this.mode.percent = false;
                }, 1000);
            }

            let cloneUpah = JSON.parse(JSON.stringify(this.upah));
            cloneUpah[id].percent.formatted = val.formatted;
            cloneUpah[id].percent.raw = val.raw;

            cloneUpah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, val.raw)
                .toString()
                .replace(".", ",");
            cloneUpah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, val.raw);

            this.upah = cloneUpah;
            this.$emit("upah", this.upah);
        },
        convertingToPercent(id, val) {
            if (this.mode.percent) {
                return;
            }
            if (!this.mode.rupiah) {
                this.mode.rupiah = true;
                this.mode.percent = false;
                setTimeout(() => {
                    this.mode.rupiah = false;
                }, 1000);
            }

            let cloneUpah = JSON.parse(JSON.stringify(this.upah));
            cloneUpah[id].percent.formatted = this.rupiahToPrecent(this.hargaLayanan, val.raw)
                .toString()
                .replace(".", ",");
            cloneUpah[id].percent.raw = this.rupiahToPrecent(this.hargaLayanan, val.raw);

            cloneUpah[id].rupiah.formatted = val.formatted;
            cloneUpah[id].rupiah.raw = val.raw;

            this.upah = cloneUpah;
            this.$emit("upah", this.upah);
        },
        recalculate() {
            for (let i = 0; i < this.tahapan.length; i++) {
                let id = this.tahapan[i].idtahapan;
                // acuan persen

                this.upah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, this.upahClone[id].percent)
                    .toString()
                    .replace();
                this.upah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, this.upahClone[id].percent);
            }
        },

        rupiahToPrecent(harga, upah) {
            let fUpah = parseFloat(upah);
            let fHarga = parseFloat(harga);

            let total = parseFloat((fUpah / fHarga) * 100);

            return isNaN(total) ? 0 : total.toFixed(2);
        },
        percentToRupiah(harga, upah) {
            let fUpah = parseFloat(upah);
            let fHarga = parseFloat(harga);

            let total = Math.round((fUpah / 100) * fHarga);
            return isNaN(total) ? 0 : total;
        },
        resetData() {
            for (let i = 0; i < this.tahapan.length; i++) {
                let id = this.tahapan[i].idtahapan;

                this.upah[id].rupiah.formatted = "";
                this.upah[id].rupiah.raw = 0;
                this.upah[id].percent.formatted = "";
                this.upah[id].percent.raw = 0;
            }
        },
    },
};
</script>

<style>
.box-tahapan {
    border: 1px solid #ededed;
}

.box-tahapan-top {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.box-tahapan-bottom {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.chev-0 {
    transform: rotate(0deg);
    transition: ease-in-out 300ms;
}

.chev-180 {
    transform: rotate(180deg);
    transition: ease-in-out 300ms;
}
</style>
